<template>
  <transition name="modal">
    <div class="msgBox" v-if="show" @touchmove="notAllowTouchMove($event)">
      <div
        class="message"
        :class="[{ expanded: expanded }, { BigExpand: BigExpand }]"
      >
        <div class="title">
          {{ title }}
          <div
            class="closeBtn"
            role="close-button"
            @click="dismiss($event)"
          ></div>
        </div>
        <div class="error" v-if="error">
          <div class="error_msg" v-for="(err, key) in error" :key="key">
            {{ err }}
          </div>
        </div>
        <Person
          v-if="type == 'person'"
          :avatar="avatar"
          :params="params"
          :actions="actions"
        ></Person>
        <Team
          v-if="type == 'team'"
          @close="close"
          :avatar="avatar"
          :params="params"
          :actions="actions"
        ></Team>
        <Club
          v-if="type == 'club'"
          :avatar="avatar"
          :params="params"
          :actions="actions"
        ></Club>
        <Note
          v-if="type == 'note'"
          :avatar="avatar"
          :params="params"
          :actions="actions"
        ></Note>
        <ContactRel
          v-if="type == 'contact_rel'"
          :avatar="avatar"
          :params="params"
          :actions="actions"
          @expand="setExpand"
        ></ContactRel>
        <RelClubEvent
          v-if="type == 'relclubevent'"
          :params="params"
        ></RelClubEvent>
        <AssignTeamToTmpl
          v-if="type == 'assignteamtmpl'"
          :params="params"
        ></AssignTeamToTmpl>
        <RelVolunteerEvent
          v-if="type == 'relvolunteerevent'"
          :params="params"
        ></RelVolunteerEvent>
        <RelFacilityEvent
          v-if="type == 'relfacilityevent'"
          :params="params"
        ></RelFacilityEvent>
        <RelHotelEvent
          v-if="type == 'relhotelevent'"
          :params="params"
        ></RelHotelEvent>
        <UserZonaEquipos
          v-if="type == 'userze'"
          :params="params"
        ></UserZonaEquipos>
        <Finance
          v-if="type == 'finance'"
          :params="params"
          :actions="actions"
          @save="goTo"
          @expand="setBigExpand"
          @close="close"
        ></Finance>
        <AssignParticipantCampusWeek
          v-if="type == 'assignparticipantcampus'"
          :params="params"
        ></AssignParticipantCampusWeek>
        <AssignPlayerMatch
          v-if="type == 'assignplayermatch'"
          :params="params"
        ></AssignPlayerMatch>
        <div v-if="type != 'finance'" class="actions">
          <div
            class="item"
            v-for="(action, key) in actions"
            v-show="action.visible == undefined || action.visible"
            :key="key"
            @click="goTo(action)"
            :class="[action.type, action.disabled ? 'disabled' : '']"
          >
            {{ action.label }}
          </div>
        </div>
      </div>
      <div class="mask" @click="dismiss($event)"></div>
    </div>
  </transition>
</template>

<script>
import Person from "./Person";
import Team from "./Team";
import Club from "./Club";
import Note from "./Note";
import ContactRel from "./ContactRel";
import RelClubEvent from "./RelClubEvent";
import AssignTeamToTmpl from "./AssignTeamToTmpl";
import RelVolunteerEvent from "./RelVolunteerEvent";
import RelFacilityEvent from "./RelFacilityEvent";
import RelHotelEvent from "./RelHotelEvent";
import UserZonaEquipos from "./UserZonaEquipos";
import Finance from "./Finance";
import AssignParticipantCampusWeek from "./AssignParticipantCampusWeek";
import AssignPlayerMatch from "./AssignPlayerMatch";
import router from "@/router";
import store from "@/store";
import i18n from "@/i18n";

export default {
  components: {
    Person,
    Team,
    Club,
    Note,
    ContactRel,
    RelClubEvent,
    UserZonaEquipos,
    Finance,
    AssignTeamToTmpl,
    RelVolunteerEvent,
    RelFacilityEvent,
    RelHotelEvent,
    AssignParticipantCampusWeek,
    AssignPlayerMatch
  },
  data() {
    return {
      show: false,
      type: "default",
      closable: true,
      avatar: false,
      type: "default",
      params: [],
      actions: [],
      title: "",
      expanded: false,
      BigExpand: false,
      error: false,
      callBackSave: function() {},
      callBackRemove: function() {},
      callBackClose: function() {}
    };
  },
  methods: {
    dismiss(event) {
      if (
        !this.closable &&
        event.target.getAttribute("role") != "close-button"
      ) {
        return;
      }
      this.show = false;
      document.body.style.overflow = "auto";
    },
    notAllowTouchMove(event) {
      event.preventDefault();
    },
    goTo(action) {
      if (typeof action.url !== "undefined") {
        router.push(action.url);
        this.callBackClose(this);
      } else {
        if (action.type == "save") {
          var aParams = {};
          if (this.type == "note")
            aParams = { note: document.getElementById("note_edit").value };

          this.callBackSave(this, aParams, store);
        } else if (action.type == "remove") {
          this.callBackRemove(this, store);
        } else if (action.action == "edit_note") {
          this.params.forEach(param => {
            if (param.id == "note") param.style = "enable";
          });
          this.actions.forEach(action => {
            if (action.type == "edit") action.visible = false;
            else if (action.type == "save") action.visible = true;
            else if (action.type == "remove") action.visible = false;
          });
        } else if (action.type == "close") {
          this.callBackClose(this);
        }
      }
    },
    showError(errors) {
      this.error = errors;
    },

    setExpand(expand) {
      this.expanded = expand;
    },
    setBigExpand(expand) {
      this.BigExpand = expand;
    },
    close() {
      this.callBackClose(this);
    }
  }
};
</script>

<style lang="scss" scoped>
.msgBox {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  -webkit-transition: opacity 0.3s ease;
  -moz-transition: opacity 0.3s ease;
  transition: opacity 0.3s ease;
  z-index: 9999;
  -webkit-user-select: none;
}
.title {
  position: relative;
  padding: 15px;
  padding-bottom: 0;
  background: #fff;
}
.closeBtn {
  position: absolute;
  top: 23px;
  right: 10px;
  transform: translateY(-50%);
  text-align: center;
  font-size: 60px;
  z-index: 999;
  cursor: pointer;
  font-size: 32px;
  font-family: Roboto-Light;
  font-weight: lighter;

  &:after {
    content: "\2A2F";
  }
}
.BigExpand {
  top: 0 !important;
  height: 100% !important;
  width: 70% !important;
}
.message {
  position: fixed;
  top: calc(#{$header-height});
  right: 0;
  height: calc(100% - #{$header-height});
  width: 25%;
  // border-radius: 10px;
  background: #fff;
  z-index: 9999;
  overflow: hidden;

  &.expanded {
    width: 50%;
  }
}
.msg {
  position: relative;
  padding: 30px 20px;
  overflow: hidden;
}
.error {
  width: 90%;
  top: 25px;
  margin: 20px auto;
  padding: 10px 15px;
  border: 1px solid red;
  background-color: rgb(243, 95, 95);

  .error_msg {
    text-align: center;
    margin-top: 5px;
    color: #fff;
    width: 100%;
    display: block;
  }
}
.actions {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px 10%;

  .item {
    line-height: 35px;
    font-size: 18px;
    font-weight: lighter;
    padding: 6px 15px 6px 15px;
    width: 100%;
    margin: 5px 0;
    border-radius: 3px;
    color: #fff;
    text-align: left;
    padding-left: 50px;

    background-color: $complem-color;
    background-repeat: no-repeat;
    background-position: left 20px center;
    background-size: 15px;
    cursor: pointer;

    &.profile {
      background-image: url(/img/goto_b.svg);
    }
    &.edit {
      background-image: url(/img/edit.svg);
    }
    &.save {
      background-color: #8bc34a;
      background-image: url(/img/download.svg);
    }
    &.close {
      background-image: url(/img/close.svg);
    }
    &.remove {
      background-color: transparent;
      color: #333;
      font-size: 16px;
      background-image: url(/img/remove.svg);
    }
  }
}
.msgFooter {
  position: relative;
  box-sizing: border-box;
  padding: 2%;
  border-top: 1px solid #e8e8e8;
  background: #fff;
  text-align: right;
  overflow: hidden;
}
.footerBtn {
  display: inline-block;
  position: relative;
  margin-right: 5px;
  margin-bottom: 0;
  padding: 0 15px;
  line-height: 1.15;
  height: 28px;
  line-height: 28px;
  border-radius: 4px;
  border: 1px solid transparent;
  border-color: #d9d9d9;
  background-color: #fff;
  color: rgba(0, 0, 0, 0.65);
  font-weight: 500;
  font-size: 12px;
  text-align: center;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  white-space: nowrap;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
